import { useFetchChoiceResults } from '@mentimeter/presentation-data-hooks/fetch-choice-results';
import { createIdentifiedResults } from '../utils/choicesResultsTransformer';
import type { Choice } from '../types';

interface UseChoiceResultsParams {
  adminKey: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
  segmentBy?: string | undefined;
  choices: Choice[];
}

export const useChoiceResults = ({
  adminKey,
  shouldFetchResults,
  sessionId,
  segmentBy,
  choices,
}: UseChoiceResultsParams) => {
  const { data, isLoading } = useFetchChoiceResults({
    adminKey,
    shouldFetchResults,
    sessionId,
    segmentBy,
  });

  const identifiedResults = createIdentifiedResults({
    results: data?.results,
    choices,
  });

  return {
    identifiedResults,
    isLoading,
  };
};
